import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getGridData } from 'src/app/shared/selectors/grid.selectors';
import { IntegrationType } from '../models/create-new-integration.model';

export const getIntegrationManagementActionsState = createSelector(
  getDragonflyState,
  (state) => state?.integrationManagementActions,
);

export const getShowDeleteRowConfirmTextValue = createSelector(
  getIntegrationManagementActionsState,
  (state) => state?.showDeleteRowConfirmText,
);

export const getShowDeactivateStatusRowConfirmTextValue = createSelector(
  getIntegrationManagementActionsState,
  (state) => state?.showDeactivateStatusRowConfirmText,
);

export const getSelectedIntegrationRowData = createSelector(
  getIntegrationManagementActionsState,
  (state) => state?.selectedIntegrationRowData,
);

export const getSelectedIntegrationCode = createSelector(
  getIntegrationManagementActionsState,
  (state) => state?.selectedIntegrationCode,
);

export const getSidenavStatus = createSelector(getIntegrationManagementActionsState, (state) => state?.openedSidenav);

export const getUpdateBtnEnabled = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('intergration.action.update') ? true : false,
);

export const getDeleteBtnEnabled = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('intergration.action.delete') ? true : false,
);

export const getIsIntegrationSystemValidForEdit = createSelector(getGridData, (data) => {
  return data.map(
    (m) =>
      m.integrationConfig.integrationSystem === IntegrationType.ENBOX ||
      m.integrationConfig.integrationSystem === IntegrationType.NEVERBOUNCE ||
      m.integrationConfig.integrationSystem === IntegrationType.APIFON_SMS ||
      m.integrationConfig.integrationSystem === IntegrationType.APIFON_VIBER_SMS ||
      m.integrationConfig.integrationSystem === IntegrationType.QC_MESSAGE_APP ||
      m.integrationConfig.integrationSystem === IntegrationType.AWS_SES ||
      m.integrationConfig.integrationSystem === IntegrationType.ELIQUA_CX ||
      m.integrationConfig.integrationSystem === IntegrationType.MSTAT_VIBER_SMS_V2,
  );
});

export const getShowEditBtn = createSelector(getUpdateBtnEnabled, getIsIntegrationSystemValidForEdit, (a, b) =>
  b.map((m) => (m === true && a === true ? true : false)),
);
